<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-bold text-gray-900">Профиль пользователя</h2>
        <button @click="emit('close')" class="text-gray-400 hover:text-gray-600">
          <XMarkIcon class="h-6 w-6" />
        </button>
      </div>

      <div class="space-y-4">
        <div>
          <label class="form-label">Имя пользователя</label>
          <input
            v-model="user.username"
            class="form-input"
            readonly
          />
        </div>

        <div>
          <label class="form-label">Полное имя</label>
          <input
            v-model="user.full_name"
            class="form-input"
          />
        </div>

        <div>
          <label class="form-label">Email</label>
          <input
            v-model="user.email"
            type="email"
            class="form-input"
          />
        </div>
      </div>

      <div class="flex justify-end space-x-3 mt-6">
        <button @click="emit('close')" class="btn-secondary">
          Отмена
        </button>
        <button @click="saveProfile" class="btn-primary">
          Сохранить
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useAuthStore } from '@/stores/auth'
import { useNotifications } from '@/composables/useNotifications'

const authStore = useAuthStore()
const { showSuccess, showError } = useNotifications()

// Определяем emit один раз
const emit = defineEmits(['close'])

const user = ref({
  username: '',
  full_name: '',
  email: ''
})

const saveProfile = async () => {
  try {
    const success = await authStore.updateProfile({
      full_name: user.value.full_name,
      email: user.value.email
    })

    if (success) {
      emit('close')
    }
  } catch (error) {
    showError('Ошибка сохранения профиля')
  }
}

onMounted(() => {
  if (authStore.user) {
    user.value = { ...authStore.user }
  }
})
</script>